module.exports = __webpack_public_path__ + "static/media/folder_yellow.53caa927.svg";